export const newsProperties: { [key: string]: string } = {
  title: 'title',
  Path: 'url',
  ESC_CREATEDDATE: 'createdDate',
  ESC_EYMAJORPUBDATE: 'major_public_date',
  vertical: 'vertical',
  contentAge: 'contentAge',
  sortDate: 'sortDate',
  escbasecrawlurl: 'spworksURL',
  ESC_EYCONTENTTYPE: 'eyContentType',
  contentType: 'contentType',
  excerpt:'description',
  ESC_LASTREVIEWEDDATE: 'lastReviewedDate',
  ESC_REVIEWTYPE: 'reviewType',
  SearchType:'SearchType',
  ESC_EYAEMID: 'ESC_EYAEMID',
  author: 'author'
};
export { newsProperties as newsViewModel };
